import { render, staticRenderFns } from "./OnlyVip.vue?vue&type=template&id=554c90a2&"
import script from "./OnlyVip.vue?vue&type=script&lang=js&"
export * from "./OnlyVip.vue?vue&type=script&lang=js&"
import style0 from "./OnlyVip.vue?vue&type=style&index=0&id=554c90a2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports